export default __webpack_public_path__ + "./img/emptyState.96384d3f69f852af9efa4e8051261c43.png";